import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FunctionComponent, useState } from 'react';
import store from 'store';
import { useCommonStyles } from '../CommonStyles';
import ResultsNotFound from '../components/ResultsNotFound';
import SearchInput from '../components/SearchInput';
import { CardData, CardTitles, getCards } from '../Data/CardData';
import Card from '../UI/Card';
import MarketingOverview from './Overview';
import PaidChannels from './PaidChannels';
import AcquisitionVelocity from './Velocity';

interface Props {
    title: string;
    category: string;
}

const Marketing: FunctionComponent<Props> = ({ title, category }) => {
    const commonClasses = useCommonStyles();

    const [selectedCard, setSelectedCard] = useState<CardData | null>(null);
    const [searchText, setSearchText] = useState('');
    const [showSearch, setShowSearch] = useState(true);

    const handleCardClick = (card: CardData) => {
        setSelectedCard(card);
        setShowSearch(false);
    };

    const showDefaultView = () => {
        setSelectedCard(null);
        setShowSearch(true);
    };

    const marketplaceId = store.getState().marketplace.marketplace.id;
    const cards = getCards(marketplaceId);

    const filteredCards = cards.filter(
        card =>
            card.category === category &&
            card.active &&
            (card.title.toLowerCase().includes(searchText.toLowerCase()) ||
                card.description.toLowerCase().includes(searchText.toLowerCase()))
    );

    const handleClickSearch = (): void => {
        setSearchText('');
    };

    const renderContent = () => {
        if (!selectedCard) {
            return (
                <div className={commonClasses.cardsContent}>
                    {filteredCards.map((card, index) => (
                        <Card
                            key={index}
                            title={card.title}
                            subTitle={card.category}
                            description={card.description}
                            premium={card.premium}
                            icon={card.icon}
                            onClick={() => {
                                handleCardClick(card);
                            }}
                        />
                    ))}
                </div>
            );
        }

        // Demo reports are not gated by plan: the premium badge on the card
        // communicates packaging, but every account can open the report.
        switch (selectedCard.title) {
            case CardTitles.MARKETING_OVERVIEW:
                return <MarketingOverview description={selectedCard.description} />;
            case CardTitles.PAID_CHANNELS:
                return <PaidChannels description={selectedCard.description} />;
            case CardTitles.ACQUISITION_VELOCITY:
                return <AcquisitionVelocity description={selectedCard.description} />;
            default:
                return null;
        }
    };

    const reportsNotFound = () => {
        return (
            <div className={commonClasses.resultNotFound}>
                <ResultsNotFound title="No reports found" />
            </div>
        );
    };

    return (
        <div className={commonClasses.container}>
            <div className={commonClasses.contentInsights}>
                <div className={commonClasses.subViewTitle}>
                    {selectedCard && (
                        <FontAwesomeIcon
                            className={commonClasses.backIcon}
                            icon={faArrowLeft}
                            onClick={showDefaultView}
                        />
                    )}
                    <h2 className={commonClasses.titleDefault}>{selectedCard ? selectedCard.title : title}</h2>
                </div>
                {showSearch && (
                    <SearchInput
                        searchText={searchText}
                        setSearchText={setSearchText}
                        showSearch={showSearch}
                        handleClickSearch={handleClickSearch}
                    />
                )}
                {filteredCards.length === 0 && reportsNotFound()}
                {renderContent()}
            </div>
        </div>
    );
};

export default Marketing;
